import { render, staticRenderFns } from "./UsersCopy.vue?vue&type=template&id=90fba5c0&scoped=true"
import script from "./UsersCopy.vue?vue&type=script&lang=js"
export * from "./UsersCopy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90fba5c0",
  null
  
)

export default component.exports